import PhotoSwipe from 'photoswipe'
// eslint-disable-next-line camelcase
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import PhotoSwipeBackdropController from './photoswipe-backdrop-controller'

const DEFAULT_GALLERY_NAME = '_main'
const ATTRIBUTE_GALLERY = 'data-pswp-gallery'
const ATTRIBUTE_TITLE = 'data-pswp-title'
const ATTRIBUTE_ITEM_ID = 'data-pswp-item-id'
const ATTRIBUTE_IMAGES = 'data-pswp-images'

export default class PhotoSwipeController {
  constructor (element, options) {
    this._element = element
    this._init()
  }

  _init () {
    const imageElements = document.querySelectorAll('[data-pswp-images]')
    const imagesData = [].map.call(imageElements, element => {
      return this._buildImageElementData(element)
    })
    this._galleries = this._buildGalleriesData(imagesData)
    this._createListeners(imageElements)
    this._initHashHandling()
  }

  _makePhotoSwipeResponsive (photoSwipe) {
    this._useLargeImages = false
    let firstResize = true
    let imageSrcWillChange

    photoSwipe.listen('beforeResize', () => {
      // gallery.viewportSize.x - width of PhotoSwipe viewport
      // gallery.viewportSize.y - height of PhotoSwipe viewport
      // window.devicePixelRatio - ratio between physical pixels and device independent pixels (Number)
      //                          1 (regular display), 2 (@2x, retina) ...

      // calculate real pixels when size changes

      const realViewportWidth = photoSwipe.viewportSize.x * window.devicePixelRatio

      // Find out if current images need to be changed
      if (this._useLargeImages && realViewportWidth < 1000) {
        this._useLargeImages = false
        imageSrcWillChange = true
      } else if (!this._useLargeImages && realViewportWidth >= 1000) {
        this._useLargeImages = true
        imageSrcWillChange = true
      }

      // Invalidate items only when source is changed and when it's not the first update
      if (imageSrcWillChange && !firstResize) {
        // invalidateCurrItems sets a flag on slides that are in DOM,
        // which will force update of content (image) on window.resize.
        photoSwipe.invalidateCurrItems()
      }

      if (firstResize) {
        firstResize = false
      }

      imageSrcWillChange = false
    })

    // gettingData event fires each time PhotoSwipe retrieves image source & size
    photoSwipe.listen('gettingData', (index, item) => {
      this._setImageProperties(item)
    })
  }

  _setImageProperties (item) {
    // Set image source & size based on real viewport width
    let useImage = item.images.m
    if (this._useLargeImages) {
      useImage = item.images.l
    }

    item.src = useImage.src
    item.w = useImage.w
    item.h = useImage.h
  }

  _initHashHandling () {
    this._tryOpenByHash()
    window.addEventListener('hashchange', function () {
      this._tryOpenByHash()
    }, false)
  }

  _tryOpenByHash () {
    const params = this._parseWindowHash()
    if (params) {
      this._openByParams(params)
    }
  }

  _buildGalleriesData (imagesData) {
    // Group image elements per gallery
    const galleriesObjects = {}
    ;[].forEach.call(imagesData, data => {
      const galleryName = data.galleryName
      if (!galleriesObjects[galleryName]) {
        galleriesObjects[galleryName] = {}
      }
      if (!galleriesObjects[galleryName][data.pid]) {
        galleriesObjects[galleryName][data.pid] = data
      }
    })
    // Transform nested objects into arrays
    const galleries = Object.keys(galleriesObjects).reduce((obj, key) => {
      obj[key] = Object.values(galleriesObjects[key])
      return obj
    }, {})
    return galleries
  }

  _buildImageElementData (element) {
    const serialized = element.getAttribute(ATTRIBUTE_IMAGES)
    const imagesData = JSON.parse(serialized)
    const galleryName = element.getAttribute(ATTRIBUTE_GALLERY) || DEFAULT_GALLERY_NAME
    const title = element.getAttribute(ATTRIBUTE_TITLE) || ''
    const id = element.getAttribute(ATTRIBUTE_ITEM_ID)
    const data = {
      pid: id,
      images: imagesData,
      galleryName: galleryName,
      title: title
    }
    return data
  }

  _createListeners (imageElements) {
    const callback = (event) => {
      const element = event.currentTarget
      event.preventDefault()
      this._imageElementClicked(element)
    }
    [].forEach.call(imageElements, element => {
      element.addEventListener('click', callback)
    })
  }

  _imageElementClicked (element) {
    const id = element.getAttribute(ATTRIBUTE_ITEM_ID)
    const galleryName = element.getAttribute(ATTRIBUTE_GALLERY) || DEFAULT_GALLERY_NAME
    this._openByParams({ gid: galleryName, pid: id })
  }

  _parseImageElementData (element) {
    const serialized = element.getAttribute('data-pswp-images')
    const data = JSON.parse(serialized)
    return data
  }

  _parseWindowHash () {
    var hash = window.location.hash.substring(1)
    var params = {}

    if (hash.length < 5) {
      return params
    }

    var vars = hash.split('&')
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue
      }
      var pair = vars[i].split('=')
      if (pair.length < 2) {
        continue
      }
      params[pair[0]] = pair[1]
    }

    if (params.gid && params.pid) {
      return params
    }
    return null
  };

  _openByParams (params) {
    const galleryName = params.gid
    const id = params.pid

    const galleryItems = this._galleries[galleryName]
    if (galleryItems) {
      // find index of this element in gallery items
      const itemIndex = galleryItems.findIndex(item => item.pid === id)
      if (itemIndex >= 0) {
        this._showPhotoswipe(galleryName, galleryItems, itemIndex)
      }
    }
  }

  _updateTitle (photoSwipe) {
    const title = photoSwipe.currItem.title || ''
    const titleElement = photoSwipe.template.querySelector('.pswp__title')
    if (titleElement) {
      titleElement.innerHTML = title
    }
  }

  _showPhotoswipe (galleryUID, items, index) {
    var options = {
      index: index,
      history: true,
      galleryUID: galleryUID,
      galleryPIDs: true,
      barsSize: { top: 100, bottom: 100 }
    }
    const photoSwipe = new PhotoSwipe(this._element, PhotoSwipeUI_Default, items, options)
    this._makePhotoSwipeResponsive(photoSwipe)
    photoSwipe.init()

    console.log('photoSwipe', photoSwipe)

    if (this._backdropController) this._backdropController.destroy()
    if (!photoSwipe.likelyTouchDevice) {
      this._backdropController = new PhotoSwipeBackdropController(photoSwipe, this)

      photoSwipe.listen('beforeChange', () => {
        this._backdropController.notifyChange()
      })
    }

    photoSwipe.listen('beforeChange', () => {
      this._updateTitle(photoSwipe)
    })
    this._updateTitle(photoSwipe)
  }
}
